'use client'

import { memo } from 'react'

import Button from 'shared/ui/Button'
import { ButtonVariants } from 'shared/ui/Button/Button.enums'

import styles from './TmsDeliveryHeader.module.scss'

interface TmsDeliveryHeaderProps {
  hasReservation: boolean
  isEditing: boolean
  onCancelEdit: () => void
}

const TmsDeliveryHeader: React.FC<TmsDeliveryHeaderProps> = ({
  hasReservation,
  isEditing,
  onCancelEdit
}) => {
  return (
    <div className={styles.headerWrapper}>
      <div className={styles.reservationHeader}>Rezerwacja terminu dostawy</div>
      {hasReservation && isEditing && (
        <Button
          variant={ButtonVariants.tertiaryText}
          onClick={onCancelEdit}
          size='small'
        >
          Anuluj edycję
        </Button>
      )}
    </div>
  )
}

export default memo(TmsDeliveryHeader)
